<template>
  <fin-dialog v-model="demoToolDialog"
              :max-width="1280"
              :fullscreen="$vuetify.breakpoint.mdAndDown"
              class="fin-demo-tool-dialog">
    <fin-demo-tool/>
  </fin-dialog>
</template>

<script>
import {EventBus} from '@/plugins/fincraft'
import FinDemoTool from '@/components/common/demoTool/DemoTool/index'

export default {
  name: 'fin-demo-tool-overlay',
  components: {
    FinDemoTool
  },
  data() {
    return {
      demoToolDialog: false,
      backLink: ' ',
      backText: '',
    }
  },
  methods: {
    showTool(show, backTo, backtext) {
      this.demoToolDialog = show
      this.backLink = backTo
      this.backText = backtext
      if (this.backLink === 'finLexikon') {
        EventBus.$emit('closeLexicon')
      }
    },
    closeTool() {
      if (this.backLink === 'finLexikon') {
        EventBus.$emit('showLexicon', undefined, false)
      }
      this.demoToolDialog = false
    },
  },
  mounted() {
    EventBus.$on('showTool', this.showTool)
    EventBus.$on('closeTool', this.closeTool)
  },
  beforeDestroy() {
    EventBus.$off('showTool', this.showTool)
  }
}
</script>

<style lang="scss" scoped>
.fin-demo-tool-dialog {
  z-index: 100;
}
</style>
